import React from 'react';
import {backendURL} from '@/api';

const DownloadFileButton = ({path, children, ...rest}) => (
  <button
    type='button'
    onClick={() => {
      window.open(backendURL(path));
    }}
    {...rest}
  >
    {children}
  </button>
);

export default DownloadFileButton;
